<template>
  <nav class="bottom-nav d-md-none" :class="{ 'bottom-nav--hidden': hidden }">
    <router-link to="/dashboard" class="bottom-nav__item" active-class="bottom-nav__item--active">
      <i class="bi bi-house"></i>
      <span class="bottom-nav__label">Anlagen</span>
    </router-link>
    <router-link to="/live-data" class="bottom-nav__item" active-class="bottom-nav__item--active">
      <i class="bi bi-activity"></i>
      <span class="bottom-nav__label">Messwerte</span>
    </router-link>
    <router-link to="/analyse" class="bottom-nav__item" active-class="bottom-nav__item--active">
      <i class="bi bi-graph-up"></i>
      <span class="bottom-nav__label">Graphen</span>
    </router-link>
    <router-link
      to="/organisation_daily_report"
      class="bottom-nav__item"
      active-class="bottom-nav__item--active"
    >
      <i class="bi bi-calendar-check"></i>
      <span class="bottom-nav__label">Tagesbericht</span>
    </router-link>
    <button class="bottom-nav__item" @click="showMore = true">
      <i class="bi bi-three-dots"></i>
      <span class="bottom-nav__label">Mehr</span>
    </button>
  </nav>

  <!-- Mehr bottom sheet -->
  <div
    v-if="showMore"
    class="offcanvas offcanvas-bottom d-md-none show"
    style="height: 60vh; visibility: visible"
  >
    <div class="offcanvas-header">
      <h5 class="offcanvas-title">Menü</h5>
      <button type="button" class="btn-close" @click="showMore = false"></button>
    </div>
    <div class="offcanvas-body">
      <ul class="list-group list-group-flush">
        <li v-if="$store.state.me.is_superuser" class="list-group-item">
          <ChooseOrganisation />
        </li>
        <NotificationOptIn
          v-if="$store.getters.isFeatureEnabled('push_notifications')"
          class="list-group-item"
        />
        <li v-if="$store.getters.isFeatureEnabled('push_notifications')" class="list-group-item">
          <router-link
            to="/settings/push-preferences"
            class="text-decoration-none text-body"
            @click="showMore = false"
          >
            <i class="fa-solid fa-bell me-2"></i>{{ $t('push_preferences_nav') }}
          </router-link>
        </li>
        <li
          v-if="
            $store.getters.isFeatureEnabled('push_notifications') &&
            $store.getters.userHasPermission('user', 'can_write')
          "
          class="list-group-item"
        >
          <router-link
            to="/settings/push-preferences-admin"
            class="text-decoration-none text-body"
            @click="showMore = false"
          >
            <i class="fa-solid fa-bell-concierge me-2"></i>{{ $t('push_admin_nav') }}
          </router-link>
        </li>
        <template v-if="$store.state.me.is_superuser">
          <li class="list-group-item list-group-item-secondary py-1">
            <small class="text-muted fw-semibold text-uppercase">Administration</small>
          </li>
          <li class="list-group-item">
            <router-link
              to="/admin/logs"
              class="text-decoration-none text-body"
              @click="showMore = false"
            >
              <i class="fa-solid fa-clipboard-list me-2"></i>Activity Logs
            </router-link>
          </li>
          <li class="list-group-item">
            <router-link
              to="/billing/plant_notification_parks"
              class="text-decoration-none text-body"
              @click="showMore = false"
            >
              <i class="fa-solid fa-money-bill-wave me-2"></i>{{ $t('admin_billing') }}
            </router-link>
          </li>
          <li class="list-group-item">
            <router-link
              to="/billing/payment_overview_parks"
              class="text-decoration-none text-body"
              @click="showMore = false"
            >
              <i class="fa-solid fa-circle-check me-2"></i>{{ $t('payment_overview_parks') }}
            </router-link>
          </li>
          <li class="list-group-item">
            <router-link
              to="/settings/system_overview"
              class="text-decoration-none text-body"
              @click="showMore = false"
            >
              <i class="bi bi-pc-display me-2"></i>Systemübersicht
            </router-link>
          </li>
        </template>
        <li class="list-group-item">
          <router-link
            to="/account/change-password"
            class="text-decoration-none text-body"
            @click="showMore = false"
          >
            <i class="fa-solid fa-unlock me-2"></i>Passwort ändern
          </router-link>
        </li>
        <li class="list-group-item">
          <a
            class="text-decoration-none text-danger"
            style="cursor: pointer"
            @click="$emit('logout')"
          >
            <i class="fa-solid fa-right-from-bracket me-2"></i>Abmelden
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div v-if="showMore" class="offcanvas-backdrop fade show" @click="showMore = false"></div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import ChooseOrganisation from '@/components/ChooseOrganisation.vue';
import NotificationOptIn from '@/components/NotificationOptIn.vue';
export default {
  name: 'BottomNav',
  components: { ChooseOrganisation, NotificationOptIn },
  emits: ['logout'],
  setup() {
    const hidden = ref(false);
    const showMore = ref(false);
    let lastScroll = 0;

    function onScroll() {
      const currentScroll = window.scrollY;
      if (currentScroll <= 0) {
        hidden.value = false;
        lastScroll = currentScroll;
        return;
      }
      hidden.value = currentScroll > lastScroll;
      lastScroll = currentScroll;
    }

    onMounted(() => window.addEventListener('scroll', onScroll, { passive: true }));
    onBeforeUnmount(() => window.removeEventListener('scroll', onScroll));

    return { hidden, showMore };
  },
};
</script>
